import { quizQuestions } from './quizQuiestion';

export const QUIZ_CONFIG_V6 = {
  startPage: 'WelcomePage',
  WelcomePage: {
    eventName: 'screen_vew_1',
    renderer: 'static',
    nextPage: 'FollowersCountPage',
  },
  FollowersCountPage: {
    eventName: 'screen_vew_8',
    renderer: 'select_list',
    nextPage: 'FollowersGoalPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: 2 / 9,
    tag: 'funnel.your_profile',
    title: 'funnel.how_many_followers',
    subtitle: 'funnel.personalized_growth_plan',
    questions: quizQuestions.FollowersCountPage,
  },
  FollowersGoalPage: {
    eventName: 'screen_vew_9',
    renderer: 'select_list',
    nextPage: 'WhatPlatformPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: 3 / 9,
    tag: 'funnel.your_profile',
    title: 'funnel.how_many_followers_in_3_months',
    questions: quizQuestions.FollowersGoalPage,
  },
  WhatPlatformPage: {
    eventName: 'screen_vew_7',
    renderer: 'select_list',
    nextPage: 'DescribeYourSelfPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: 4 / 9,
    title: 'funnel.what_platform_use',
    tag: 'funnel.your_profile',
    questions: quizQuestions.WhatPlatformPage,
  },
  DescribeYourSelfPage: {
    eventName: 'screen_vew_5',
    renderer: 'select_list',
    nextPage: 'ContentAboutPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: 5 / 9,
    title: 'funnel.how_would_you_describe_yourself',
    tag: 'funnel.your_profile',
    questions: quizQuestions.DescribeYourSelfPage,
  },
  ContentAboutPage: {
    eventName: 'screen_vew_6',
    renderer: 'select_list',
    nextPage: 'PotentialProgressPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: 6 / 9,
    title: 'funnel.what_content_about',
    tag: 'funnel.your_profile',
    questions: quizQuestions.ContentAboutPage,
  },
  PotentialProgressPage: {
    eventName: 'screen_vew_10',
    renderer: 'static',
    nextPage: 'UserLevelPage',
    showHeader: true,
  },
  UserLevelPage: {
    eventName: 'screen_vew_11',
    renderer: 'select_list',
    nextPage: 'CreatorJourneyComparisonPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: 7 / 9,
    tag: 'funnel.your_profile',
    title: 'funnel.where_are_you_in_your_creator_journey',
    questions: quizQuestions.UserLevelPage,
    withSubmit: true,
  },
  CreatorJourneyComparisonPage: {
    eventName: 'screen_vew_12',
    renderer: 'static',
    nextPage: 'WantToAchievePage',
    showHeader: true,
  },
  WantToAchievePage: {
    eventName: 'screen_vew_13',
    renderer: 'select_list',
    nextPage: 'MappedOutPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: 8 / 9,
    tag: 'funnel.your_profile',
    title: 'funnel.what_do_you_want_to_achieve',
    questions: quizQuestions.WantToAchievePage,
    withSubmit: true,
    multiSelect: true,
  },
  MappedOutPage: {
    eventName: 'screen_vew_15',
    renderer: 'static',
    nextPage: 'HoldingBackPage',
    showHeader: true,
  },
  HoldingBackPage: {
    eventName: 'screen_vew_16',
    renderer: 'select_list',
    nextPage: 'GrowthGraphPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 1 / 6, 0],
    tag: 'funnel.your_challenges',
    title: 'funnel.holding_back',
    questions: quizQuestions.HoldingBackPage,
    withSubmit: true,
    multiSelect: true,
  },
  GrowthGraphPage: {
    eventName: 'screen_vew_19',
    renderer: 'static',
    nextPage: 'DontUnderstandAlgorithmsPage',
    showHeader: true,
  },
  DontUnderstandAlgorithmsPage: {
    eventName: 'screen_vew_20',
    renderer: 'select_list',
    nextPage: 'OverwhelmedByToolsPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 2 / 6, 0],
    tag: 'funnel.your_challenges',
    title: 'funnel.dont_understand_algorithms',
    questions: quizQuestions.agreement,
  },
  OverwhelmedByToolsPage: {
    eventName: 'screen_vew_22',
    renderer: 'select_list',
    nextPage: 'SpendTooMAtchTimePage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 3 / 6, 0],
    tag: 'funnel.your_challenges',
    title: 'funnel.overwhelmed_by_tools',
    questions: quizQuestions.agreement,
  },
  SpendTooMAtchTimePage: {
    eventName: 'screen_vew_25',
    renderer: 'select_list',
    nextPage: 'GrowFastWithSystemPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 4 / 6, 0],
    tag: 'funnel.your_challenges',
    title: 'funnel.spend_too_much_time',
    questions: quizQuestions.agreement,
  },
  GrowFastWithSystemPage: {
    eventName: 'screen_vew_26',
    renderer: 'select_list',
    nextPage: 'YouNotOnlyOnePage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 5 / 6, 0],
    tag: 'funnel.your_challenges',
    title: 'funnel.grow_faster_with_system',
    questions: quizQuestions.agreement,
  },
  YouNotOnlyOnePage: {
    eventName: 'screen_vew_27',
    renderer: 'static',
    nextPage: 'ClearSystemPage',
    showHeader: true,
  },
  ClearSystemPage: {
    eventName: 'screen_vew_28',
    renderer: 'static',
    nextPage: 'ContentCreationEasierPage',
    showHeader: true,
  },
  ContentCreationEasierPage: {
    eventName: 'screen_vew_29',
    renderer: 'select_list',
    nextPage: 'SpentTimeOnContentPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 1, 1 / 8],
    tag: 'funnel.your_plan',
    title: 'funnel.content_creation_easier',
    questions: quizQuestions.ContentCreationEasierPage,
    withSubmit: true,
    multiSelect: true,
    continueButtonText: 'dynamicPage.buttons.next',
  },
  SpentTimeOnContentPage: {
    eventName: 'screen_vew_30',
    renderer: 'select_list',
    nextPage: 'PlanTargetsPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 1, 2 / 8],
    tag: 'funnel.your_plan',
    title: 'funnel.spent_time_on_content',
    questions: quizQuestions.SpentTimeOnContentPage,
  },
  PlanTargetsPage: {
    eventName: 'screen_vew_33',
    renderer: 'select_list',
    nextPage: 'AvoidWhatPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 1, 3 / 8],
    tag: 'funnel.your_plan',
    title: 'funnel.plan_targets',
    questions: quizQuestions.PlanTargetsPage,
    withSubmit: true,
    multiSelect: true,
    continueButtonText: 'dynamicPage.buttons.next',
  },
  AvoidWhatPage: {
    eventName: 'screen_vew_34',
    renderer: 'select_list',
    nextPage: 'KnowHowMonetizePage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 1, 4 / 8],
    tag: 'funnel.your_plan',
    title: 'funnel.avoid_what',
    questions: quizQuestions.AvoidWhatPage,
    withSubmit: true,
    multiSelect: true,
    continueButtonText: 'dynamicPage.buttons.next',
  },
  KnowHowMonetizePage: {
    eventName: 'screen_vew_35',
    renderer: 'select_list',
    nextPage: 'StartMonetizingPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 1, 5 / 8],
    tag: 'funnel.your_plan',
    title: 'funnel.know_how_monetize',
    questions: quizQuestions.KnowHowMonetizePage,
  },
  StartMonetizingPage: {
    eventName: 'screen_vew_36',
    renderer: 'select_list',
    nextPage: 'IncomeGoalPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 1, 6 / 8],
    tag: 'funnel.your_plan',
    title: 'funnel.start_monetizing',
    questions: quizQuestions.StartMonetizingPage,
  },
  IncomeGoalPage: {
    eventName: 'screen_vew_37',
    renderer: 'select_list',
    nextPage: 'SummaryPage',
    showHeader: true,
    showProgressBar: true,
    progressBarValue: [1, 1, 7 / 8],
    tag: 'funnel.your_plan',
    title: 'funnel.monthly_income_goal',
    questions: quizQuestions.IncomeGoalPage,
  },
  SummaryPage: {
    eventName: 'screen_vew_38',
    renderer: 'static',
    nextPage: 'AnalyzingPage',
    showHeader: true,
  },
  AnalyzingPage: {
    eventName: 'screen_vew_39',
    renderer: 'static',
    nextPage: 'EmailPage',
    showHeader: true,
  },
  EmailPage: {
    eventName: 'email',
    renderer: 'static',
    showHeader: true,
    nextPage: 'SubscribeToUpdatesPage',
  },
  SubscribeToUpdatesPage: {
    eventName: 'screen_vew_41',
    renderer: 'static',
    nextPage: 'PossibleTrajectoryPage',
    showHeader: true,
  },
  PossibleTrajectoryPage: {
    eventName: 'screen_vew_42',
    renderer: 'static',
    nextPage: null,
    showHeader: true,
  },
};

export const QUIZ_CONFIG_V6_1 = {
  ...QUIZ_CONFIG_V6,
  WelcomePage: {
    ...QUIZ_CONFIG_V6.WelcomePage,
    title: 'funnel.start_journey',
  },
};

export const QUIZ_CONFIG_V6_2 = {
  ...QUIZ_CONFIG_V6,
  startPage: 'StopScrollingPage',
  StopScrollingPage: {
    eventName: 'screen_vew_1',
    renderer: 'static',
    nextPage: 'FollowersCountPage',
    title: 'funnel.start_journey',
  },
};

export const QUIZ_CONFIG_V6_3 = {
  ...QUIZ_CONFIG_V6,
  startPage: 'StopScrollingWithFollowersPage',
  StopScrollingWithFollowersPage: {
    eventName: 'screen_vew_1',
    renderer: 'static',
    nextPage: 'FollowersCountPage',
    title: 'funnel.start_journey',
  },
};

export const QUIZ_CONFIG_V6_4 = {
  ...QUIZ_CONFIG_V6,
  startPage: 'LoadingQuizDarkPage',
  LoadingQuizDarkPage: {
    eventName: 'screen_vew_1',
    renderer: 'static',
    nextPage: 'FollowersCountPage',
  },
};
